<template lang="html">
  <div>
    <div
      v-if="!editing"
      class="row middle-xs col-xs-12"
      style="padding: 10px 0 15px 0"
    >
      <pl-button class="pl-primary-reverse b" @click.native="$router.go(-1)"
        >< GO BACK</pl-button
      >
      <div class="col-xs-1"></div>
    </div>

    <div class="container row" :class="{ pt4: editing }">
      <!-- LEFT CONTAINER -->
      <div class="col-xs-12 col-sm-8 pl-box-shadow pv4 mb4 left-container">
        <!-- Editor -->
        <tinymce
          v-if="show_editor"
          :savedContent="premade.prompt"
          @change="handlePromptChange"
        />
      </div>

      <!-- RIGHT CONTAINER -->
      <div class="col-xs-12 col-sm-4 mb4">
        <div class="row middle-xs ph3">
          <div class="online-rt">
            <img
              width="28px"
              height="28px"
              src="/static/online_roundtable_icons/online.svg"
            />
            <span class="ml2 f5 b"> Written Roundtable </span>
          </div>
        </div>

        <div class="mt3 ph3 premade-fields">
          <!-- Parlay Certified -->
          <div class="left-xs flex mb3">
            <pl-checkbox v-model="is_certified" />
            <span>Parlay Certified?</span>
          </div>

          <!-- Buttons -->
          <div class="col-xs-12 privacy-save">
            <pl-button @click.native="saveChanges" class="f3 pl-primary b"
              >SAVE CHANGES</pl-button
            >
            <!-- Privacy -->
            <div class="privacy-dropdown">
              <pl-menu direction="right" :menuSize="2">
                <pl-button slot="menu_trigger">
                  <strong>{{ accessibility }}</strong>
                  <i class="fa fa-caret-down pa1" />
                </pl-button>
                <ul menu-content>
                  <li @click="accessibility = 'Public'">Public</li>
                  <li @click="accessibility = 'Unlisted'">Unlisted</li>
                  <li @click="accessibility = 'Draft'">Draft</li>
                </ul>
              </pl-menu>
            </div>
          </div>

          <!-- Duplicate / Delete -->
          <div class="mt3 flex justify-between">
            <span
              @click="duplicateRoundtable"
              class="pl-title b black-50 link-button"
              >DUPLICATE</span
            ><span
              @click="deleteRoundtable"
              class="pl-title b black-50 link-button"
              >DELETE</span
            >
          </div>
          <!-- Created Date -->
          <div class="mt4">
            <span>Created:</span>
            {{ premade_created_date }}
          </div>

          <!-- Title -->
          <div class="mt4">
            <span class="field-label">Title</span>
            <pl-input
              v-model="title"
              @keyup.native="checkWords"
              class="mv2 f3"
            ></pl-input>
          </div>

          <!-- Thumbnail -->
          <div class="mt4">
            <img
              v-if="!uploading_avatar"
              :src="get_thumbnail_on_amazon_aws"
              alt="No Thumbnail Yet - Click Below to Add One"
              style="width: 50%"
            />
            <pl-spinner v-if="uploading_avatar" class="x1" />
          </div>
          <div class="mt3">
            <label
              for="file-upload"
              class="pl-subheading pa1"
              style="cursor: pointer; border: 1px solid black"
            >
              Change or Add Thumbnail </label
            ><br />
            <input
              id="file-upload"
              type="file"
              ref="file_to_upload"
              accept="image/webp, image/jpeg, image/png"
              class="dn"
              @change="selectFileToUpload"
            />
          </div>

          <!-- Image Source -->
          <p class="field-label mt4 mb0">
            Image source (if image is not your own)
          </p>
          <pl-input v-model="image_source" class="mb4 f3"></pl-input>

          <!-- Author email -->
          <p class="field-label mt4 mb0">Author email</p>
          <pl-input v-model="author_email" class="mb4 f3"></pl-input>

          <!-- Disclaimer -->
          <div v-if="isParlayAdmin">
            <p class="field-label">Sensitive Content?</p>
            <toggle-button
              :labels="true"
              v-model="disclaimer"
              :sync="true"
              class="ml2"
              color="#72ccd7"
            />
          </div>
          <!-- Subject Areas -->
          <div class="mt4">
            <span class="field-label">Subject Areas:</span>
            <multiselect
              class="flex mv2"
              v-model="selected_subjects"
              :options="subjects"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              :preselect-first="false"
              placeholder="Select subjects"
              label="name"
              track-by="id"
            >
              <template slot="selection" slot-scope="{ values, search, isOpen }"
                ><span
                  class="w-auto multiselect__single"
                  v-if="values.length &amp;&amp; !isOpen"
                  v-for="(subj, subjIndex) of values"
                  >{{ subj.name }}{{ subjIndex < values.length - 1 ? ',' : '' }}
                </span></template
              >
            </multiselect>
          </div>

          <!-- Grades -->
          <p class="field-label mt4 mb0">Grades</p>
          <div class="grades">
            <div
              class="dib ml3"
              v-for="(grade, index) in grade_levels"
              :key="grade.id"
            >
              <div class="flex">
                <pl-checkbox
                  v-model="selected_grade_levels"
                  :value="grade.id"
                />
                <span>{{ grade.grade }}</span>
              </div>
            </div>
          </div>

          <!-- Tags -->
          <div class="mt4">
            <span class="field-label">Tags:</span>
            <multiselect
              class="flex mv2"
              v-model="selectedTags"
              tag-placeholder="Add this as new tag"
              placeholder="Search or add a tag"
              label="name"
              track-by="name"
              :options="suggestedTags"
              :multiple="true"
              :taggable="true"
              @tag="addTag"
              @search-change="searchTags($event)"
            >
            </multiselect>
          </div>

          <!-- Skills -->
          <div class="mt4">
            <span class="field-label">Skills:</span>
            <multiselect
              class="flex mv2"
              v-model="selectedSkills"
              placeholder="Select skills"
              label="name"
              track-by="name"
              :options="skills"
              :multiple="true"
            >
            </multiselect>
          </div>

          <!-- Description and publisher notes details -->
          <div class="mt4">
            <span class="field-label">Description</span>
            <textbox
              v-model="description"
              :showSubmitButton="false"
              placeholder="Write a brief description for this RoundTable here"
            />
          </div>

          <!-- publisher notes details -->
          <div class="mt4">
            <span class="field-label">Publisher Notes</span>
            <textbox
              class="mv2"
              v-model="publisher_notes"
              :showSubmitButton="false"
              placeholder="Write in publisher's notes/instructions here"
            />
          </div>

          <!-- Universe Categories -->
          <div class="mt4">
            <span class="field-label">Collections</span>
            <div v-for="(category, index) in categories" :key="category.id">
              <pl-checkbox v-model="selected_categories" :value="category.id" />
              <span style="margin-left: 30px">{{ category.name }}</span>
            </div>
          </div>

          <!-- Universe Peer Assessment Questions -->
          <div class="mt4">
            <span class="field-label">Guided Feedback Questions:</span>
            <div class="mt3">
              <div
                class="mv4 flex justify-between"
                v-for="(question, index) in peer_assessment_questions"
                :key="question.question"
              >
                {{ question.question }}
                <br />
                <toggle-button
                  @change="handlePeerAssessmentToggle($event, index)"
                  :value="question.is_active"
                  color="#72ccd7"
                  :labels="true"
                />
              </div>
              <div class="flex justify-between">
                <pl-input
                  v-model="new_peer_feedback_question"
                  class="col-xs-10"
                />
                <pl-button
                  @click.native="handleNewPeerFeedbackQuestion"
                  class="pl-primary"
                  style="min-width: 36px; border-radius: 100%"
                >
                  <i class="fa fa-plus" aria-hidden="true" />
                </pl-button>
              </div>
            </div>
          </div>
          <br />

          <!-- Footer -->
          <div class="mt4">
            <span class="field-label">PREMADE ID</span>
            <div class="mt2">{{ premade.id }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import tinymce from 'components/textEditor/tinymce.vue';
  import premadeServices from 'services/premades/premadeServices';
  import { EventBus } from 'utils/event-bus';
  import { mapGetters } from 'vuex';
  import Textbox from 'components/textbox.vue';
  import amazonServices from 'services/amazonAWS';
  import Multiselect from 'vue-multiselect';
  import adminServices from 'services/admin/adminServices';
  import moment from 'moment';

  export default {
    components: {
      tinymce,
      Textbox,
      Multiselect,
    },
    data() {
      return {
        new_peer_feedback_question: '',
        publisher_notes: '',
        description: '',
        author_email: '',
        disclaimer: false,
        selected_grade_levels: [],
        selected_subjects: [],
        selected_categories: [],
        subjects: [],
        grade_levels: [],
        categories: [],
        peer_assessment_questions: [],
        fileToUpload: [],
        edited_prompt: '',
        title: '',
        thumbnail_url: '',
        is_published: false,
        premade: {},
        show_editor: false,
        suggestedTags: [],
        selectedTags: [],
        initialTags: [],
        skills: [],
        selectedSkills: [],
        editing: false,
        is_certified: false,
        image_source: '',
        accessibility: '',
        uploading_avatar: false,
      };
    },
    computed: {
      ...mapGetters(['getProfile']),
      get_thumbnail_on_amazon_aws() {
        if (
          this.thumbnail_url.includes('/static') ||
          this.thumbnail_url.includes('i.vimeocdn')
        )
          return this.thumbnail_url;
        return amazonServices.getImageOnS3(
          '341x192',
          'premade_thumbnails',
          this.thumbnail_url
        );
      },
      isParlayAdmin() {
        return (this.getProfile.role = 'admin');
      },
      // Remove all special characters and returns the new file name
      filtered_file_name() {
        const filtered_title = this.title.replace(/[^\w\s]/gi, '');
        return `${filtered_title
          .split(' ')
          .join('_')
          .toLowerCase()}_${Date.now().toString()}.webp`;
      },
      premade_created_date() {
        return this.premade.created_at
          ? moment(this.premade.created_at).format('MMMM Do YYYY')
          : '';
      },
    },
    methods: {
      removePeerAssesementQuestion(index) {
        this.peer_assessment_questions.splice(index, 1);
      },
      handleNewPeerFeedbackQuestion() {
        if (this.new_peer_feedback_question) {
          this.peer_assessment_questions.push({
            question: this.new_peer_feedback_question,
            is_active: false,
            is_custom: false,
          });
          this.new_peer_feedback_question = '';
        }
      },
      handlePeerAssessmentToggle(event, index) {
        this.peer_assessment_questions[index].is_active = event.value;
      },
      // Get the file sent by the user and send it formatted to save on Amazon AWS
      selectFileToUpload() {
        this.fileToUpload = this.$refs.file_to_upload.files;

        if (this.fileToUpload[0].size > 1000000) {
          EventBus.$emit('toast-msg', 'Invalid file size. (Max. 1MB)');
          return;
        }
        if (
          this.fileToUpload[0].type !== 'image/png' &&
          this.fileToUpload[0].type !== 'image/jpeg' &&
          this.fileToUpload[0].type !== 'image/webp' &&
          this.fileToUpload[0].type !== 'image/gif'
        ) {
          EventBus.$emit(
            'toast-msg',
            'Invalid file type. (Accepted .jpeg, .png, .gif, .webp)'
          );
          return;
        }

        const formattedFile = new File(
          [this.fileToUpload[0]],
          `${this.filtered_file_name}`,
          { type: 'image/webp' }
        );

        const folderName = 'premade_thumbnails';

        this.uploading_avatar = true;
        amazonServices.postFileToS3(formattedFile, folderName).then((r) => {
          this.thumbnail_url = r.data.name;
          this.uploading_avatar = false;
          premadeServices.editPremade(this.$route.params.premadeID, {
            thumbnail_url: this.filtered_file_name,
          });
        });
      },
      handlePromptChange(val) {
        this.edited_prompt = val;
      },
      saveAndTogglePublish() {
        this.is_published = !this.is_published;
        this.saveChanges();
      },
      saveChanges() {
        premadeServices
          .editPremade(this.$route.params.premadeID, {
            prompt: this.edited_prompt,
            is_published: this.is_published,
            title: this.title,
            grade_levels: this.selected_grade_levels.map((gId) => {
              return { id: gId };
            }),
            subjects: this.selected_subjects.map((s) => {
              return { id: s.id };
            }),
            categories: this.selected_categories.map((cId) => {
              return { id: cId };
            }),
            author_email: this.author_email,
            description: this.description,
            publisher_notes: this.publisher_notes,
            peer_assessment_questions: this.peer_assessment_questions,
            is_certified: this.is_certified,
            image_source: this.image_source,
            accessibility: this.accessibility,
            disclaimer: this.disclaimer,
            tags: this.selectedTags.map((t) =>
              t.id !== null ? t : { name: t.name }
            ),
            skills: this.selectedSkills,
          })
          .then(({ data }) => {
            this.premade = data;
            this.show_editor = true;
            EventBus.$emit('toast-msg', 'Premade edited!');
          });
      },
      duplicateRoundtable() {
        premadeServices
          .duplicatePremade(this.$route.params.premadeID)
          .then(() => {
            EventBus.$emit('toast-msg', 'Premade duplicated!');
          });
      },
      deleteRoundtable() {
        premadeServices.deletePremade(this.$route.params.premadeID).then(() => {
          EventBus.$emit('toast-msg', 'Premade deleted!');
          this.$router.go(-1);
        });
      },
      searchTags(ev) {
        if (ev === '') {
          this.suggestedTags = this.initialTags;
        } else {
          adminServices.getTagsByTerm(ev).then((res) => {
            this.suggestedTags = res.data.res;
          });
        }
      },
      addTag(newTag) {
        const tag = {
          name: newTag,
          id: null,
        };
        this.suggestedTags.push(tag);
        this.selectedTags.push(tag);
      },
      checkWords(e) {
        const BACKSPACE = 8;
        const DELETE = 46;
        const MAX_WORDS = 15;
        const valid_keys = [BACKSPACE, DELETE];
        let words = this.title.split(' ');

        if (words.length >= MAX_WORDS && valid_keys.indexOf(e.keyCode) === -1) {
          e.preventDefault();
          words.length = MAX_WORDS;
          this.title = words.join(' ');
        }
      },
    },
    mounted() {
      this.editing = this.$route.query.editing;
      premadeServices
        .showPremade(this.$route.params.premadeID)
        .then(({ data }) => {
          this.selected_grade_levels = data.grade_levels.map((g) => g.id);
          this.selected_subjects = data.subjects;
          this.selected_categories = data.universe_categories.map((g) => g.id);
          this.peer_assessment_questions = data.peer_assessment_questions;
          this.premade = data;
          this.edited_prompt = data.prompt;
          this.is_published = data.is_published;
          this.title = data.title;
          this.thumbnail_url = data.thumbnail_url;
          this.show_editor = true;
          this.author_email = data.author ? data.author.email : '';
          this.disclaimer = data.disclaimer;
          this.description = data.description;
          this.publisher_notes = data.publisher_notes;
          this.is_certified = data.is_certified;
          this.image_source = data.image_source;
          this.accessibility = data.accessibility;
          this.suggestedTags = data.tags;
          this.selectedTags = data.tags;
          this.initialTags = data.tags;
          this.selectedSkills = data.skills;
        });

      // Populate the grades and subjects in local state
      this.$store.dispatch('getAllSubjects').then((results) => {
        this.subjects = results;
      });

      this.$store.dispatch('getAllGradeLevels').then((results) => {
        this.grade_levels = results;
      });

      this.$store.dispatch('getAllUniverseCategories').then((results) => {
        this.categories = results;
      });

      this.$store.dispatch('getAllSkills').then((results) => {
        this.skills = results;
      });
    },
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
  .online-rt
    margin-left: 5px
    padding: 5px 20px
    background-color: #EAF8F9
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped lang="scss">
  .pl-box-shadow {
    border-radius: 8px;
    box-shadow: none;
    border: 1px solid #979797;
  }

  .privacy-save {
    display: flex;
    justify-content: space-between;
    padding: 0;
    button {
      font-size: 18px;
      margin: 0;
      width: calc(65% - 14px);
    }
    .privacy-dropdown {
      padding-right: 0;
      width: 35%;
      .dropdown {
        width: 100%;
        button {
          width: 100%;
          border: 1px solid #000;
        }
      }
    }
  }

  .premade-fields .input-container {
    padding: 0;
    margin-top: 0.5rem;
  }

  .field-label {
    color: #2c3853;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 27px;
    font-size: 14px;
  }

  .grades {
    margin-left: -1rem;
  }

  .link-button {
    cursor: pointer;
    &:hover {
      color: #2c3853;
    }
  }

  .container {
    margin: auto;
  }
</style>

<style lang="scss">
  .premade-fields {
    .multiselect {
      .multiselect__single {
        width: auto;
      }
      .multiselect__tags {
        border: 2px solid #e1e8ee;
        width: 100%;
      }
      .multiselect__tag {
        background-color: #d8d8d8;
        border-radius: 12px;
        height: 25px;
        color: rgba(41, 41, 41, 0.75);
        font-size: 18px;
        letter-spacing: 0;
        line-height: 25px;
        padding: 0 26px 0 10px;
        i {
          right: 6px;
          top: 6px;
          bottom: 0;
          font-weight: 700;
          font-style: normal;
          width: 14px;
          text-align: center;
          line-height: 6px;
          transition: all 0.2s ease;
          border-radius: 50%;
          height: 14px;
          padding-top: 3px;
          background-color: #787878;
          color: #d8d8d8;
          &::after {
            color: #d8d8d8;
          }
        }
      }
    }
    .premade-fields .input-container {
      .label-default {
        display: none;
      }
    }
  }

  .left-container {
    .mce-tinymce.mce-container.mce-panel {
      height: 100%;
      div.mce-container-body.mce-stack-layout {
        height: 100%;
        display: flex;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// premadeForm.vue?5942f5b2